// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

import prods from "pages/LandingPages/Productos/data/productos"
import FilledImageCard from "examples/Cards/InfoCards/FilledImageCard";

function Productos() {
  const sectores = prods.map(({ image, title, description, producto, width }) => (
    <Grid item xs={12} lg={4} key={title}>
      <FilledImageCard
        variant="contained"
        color="info"
        image={image}
        title={title}
        description={description}
        producto={producto}
        action={{
            label: "¡Conoce más!"
        }}
        width={width}
      />
    </Grid>
  ));

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox minHeight="30vh"></MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h1" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                NUESTROS PRODUCTOS
              </MKTypography>
              <MKTypography variant="body1" color="text">
                En ARES tenemos la correcta selección de equipo de bombeo industrial con marcas líderes en el mercado así como bombas sustitutas con la misma garantía y calidad pero a precios mucho más bajos para satisfacer sus necesidades.
              </MKTypography>
              <MKTypography variant="body1" color="text">
                Trabajamos con todo tipo de aplicaciones, desde agua hasta los  productos más químicos  y corrosivos, para atender a toda industria.
              </MKTypography>
              <MKTypography variant="body1" color="text">
                Nuestro equipo de ventas puede ayudarte en su selección y ayudar a garantizar que tus bombas funcionen con la máxima eficiencia sin importar cuál sea la aplicación.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <Container>
          <Grid container spacing={3}>
            {sectores}
          </Grid>
        </Container>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Productos;
